import { useTranslation } from "react-i18next";

interface FloorPlanTabsProps {
  open: boolean;
  onToggle: () => void;
}

/**
 * Klickbare Tab-Leiste "Grundriss" (de) / "Floor Plan" (en).
 * Der Grundriss klappt erst auf, wenn die Leiste gedrückt wird.
 */
export function FloorPlanTabs({ open, onToggle }: FloorPlanTabsProps) {
  const { i18n } = useTranslation();
  const isDe = i18n.language.startsWith("de");

  return (
    <button
      type="button"
      onClick={onToggle}
      aria-expanded={open}
      className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm whitespace-nowrap cursor-pointer transition-colors ${
        open
          ? "bg-accent-500 text-background-50"
          : "bg-background-100 text-foreground-700 hover:bg-background-200"
      }`}
    >
      <i className="ri-layout-line"></i>
      <span>{isDe ? "Grundriss" : "Floor Plan"}</span>
      <i className={open ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}></i>
    </button>
  );
}

interface FloorPlanImageProps {
  deImg: string;
  enImg: string;
  alt: string;
}

/**
 * Karte mit dem Grundriss – zeigt automatisch die deutsche oder englische
 * Version passend zur Website-Sprache.
 */
export function FloorPlanImage({ deImg, enImg, alt }: FloorPlanImageProps) {
  const { i18n } = useTranslation();
  const isDe = i18n.language.startsWith("de");
  const src = isDe ? deImg : enImg;

  return (
    <div className="bg-background-100 border border-background-200 rounded-lg overflow-hidden mb-8">
      <div className="p-4 md:p-6">
        <img src={src} alt={alt} className="w-full h-auto object-contain" />
      </div>
    </div>
  );
}